module.exports = __webpack_public_path__ + "img/antes_despues_154.6c37d641.png";